import { useMemo } from 'react';
import {
  useSelectedCall,
  useSelectedCallerID,
} from '@rsos/reduxDataStore/src/features/emergencyCalls';
import { getCallLocation } from './towProCallLookup';
import {
  TOWPRO_INITIAL_FORM_VALUES,
  type TowProFormValues,
} from './towProFormConstants';

/**
 * Initial tow request form values. When the form opens with a call selected,
 * the related call and the call's most recent location pre-populate.
 */
export function useTowProInitialFormValues(): TowProFormValues {
  const selectedCallerID = useSelectedCallerID();
  const selectedCall = useSelectedCall();

  return useMemo(() => {
    if (!selectedCallerID || !selectedCall) {
      return TOWPRO_INITIAL_FORM_VALUES;
    }

    const baseValues: TowProFormValues = {
      ...TOWPRO_INITIAL_FORM_VALUES,
      related_call: selectedCallerID,
    };

    const callLocation = getCallLocation(selectedCall);
    if (!callLocation) {
      return baseValues;
    }

    return {
      ...baseValues,
      address: callLocation.address,
      latitude: callLocation.latitude,
      longitude: callLocation.longitude,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- selectedCall intentionally excluded: including it would reset the form every time the call receives a location update
  }, [selectedCallerID]);
}
